<th>
  <label [attr.for]="id"
         class="col-form-label"
         i18n>{{ label }}</label>
</th>
<td class="align-middle">
  @if (!editing) {
  <span class="col-form-label">
    <ng-content></ng-content>
  </span>
  } @else {
  <div class="form-check">
    <input [attr.id]="id"
           [formControlName]="id"
           type="checkbox"
           class="form-check-input position-static" />
  </div>
  }
</td>
<td [innerHtml]="description"></td>